<template>
  <div id="app">
    <el-container>
      <el-header><NavigationMenu/></el-header>
      <el-main><router-view/></el-main>
    </el-container>
  </div>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu';


export default {
  name: 'app',
  components: {
    NavigationMenu
  }
}
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>